import { render } from "./TextoEsPins.vue?vue&type=template&id=6d02a118&scoped=true"
import script from "./TextoEsPins.vue?vue&type=script&lang=js"
export * from "./TextoEsPins.vue?vue&type=script&lang=js"

import "./TextoEsPins.vue?vue&type=style&index=0&id=6d02a118&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d02a118"]])

export default __exports__